import FormationsTaughtForm from "@/components/formateur/FormationsTaughtForm";

export default function FormationsEditPage() {
    return (
        <div className="mx-auto max-w-5xl px-6 py-10" data-testid="page-formations-taught-edit">
            <div className="mb-8">
                <div className="text-xs uppercase tracking-[0.25em] text-brand-orange">Mon expertise</div>
                <h1 className="mt-3 font-display text-4xl font-normal tracking-tightest">
                    Mes formations enseignables
                </h1>
                <p className="mt-2 max-w-2xl text-brand-smoke">
                    Mettez à jour la liste des formations que vous êtes en mesure d'animer. Cette information est utilisée pour vous proposer automatiquement les sessions correspondantes.
                </p>
            </div>
            <FormationsTaughtForm mode="edit" />
        </div>
    );
}
